import { ReferentialKey } from 'api/referential';
import { FormikSelectCard, FormikSelectCardProps } from 'components/forms/formik/FormikSelectCard';
import { useSelector } from 'react-redux';
import { selectReferentialByKey } from '../selectors/selectReferentialByKey';

interface FormikSelectCardContainerProps extends FormikSelectCardProps {
  referentialKey?: ReferentialKey;
}

/** FormikSelectCard alimenté par un référentiel : la version connectée vit
 * dans la feature qui possède la donnée ; le socle reste bête. */
export const FormikSelectCardContainer: React.FC<FormikSelectCardContainerProps> = ({
  referentialKey,
  items,
  ...props
}) => {
  const referential = useSelector(selectReferentialByKey(referentialKey));
  const newItems = referential && referential.length > 0 ? referential : [];
  if (newItems.length > 0) {
    return <FormikSelectCard items={newItems} {...props} />;
  }
  return <FormikSelectCard items={items} {...props} />;
};
